import { useState, useEffect, useCallback } from "react";

const useAutoLogout = (logout, timeout = 900000) => {
  const [showWarning, setShowWarning] = useState(false);
  const [remainingTime, setRemainingTime] = useState(timeout / 1000);
  const warningTime = 30000;

  const resetTimer = useCallback(
    (event) => {
      console.log(
        `Activity detected: ${event.type} at ${new Date().toISOString()}`
      );
      window.clearTimeout(window.logoutTimer);
      window.clearTimeout(window.warningTimer);
      setShowWarning(false);
      setRemainingTime(timeout / 1000);
      window.logoutTimer = window.setTimeout(() => {
        console.log(
          `Logging out due to inactivity at ${new Date().toISOString()}`
        );
        logout();
      }, timeout);
      window.warningTimer = window.setTimeout(() => {
        setShowWarning(true);
        startCountdown(warningTime);
      }, timeout - warningTime);
    },
    [logout, timeout]
  );

  const startCountdown = (time) => {
    let remaining = time / 1000;
    const countdownInterval = setInterval(() => {
      setRemainingTime(remaining);
      remaining -= 1;
      if (remaining < 0) {
        clearInterval(countdownInterval);
      }
    }, 1000);
    window.logoutCountdownInterval = countdownInterval;
  };

  useEffect(() => {
    const events = [
      //   "mousemove",
      //   "mousedown",
      //   "mouseup",
      "click",
      "scroll",
      //   "keydown",
      //   "keyup",
      //   "touchstart",
      //   "touchmove",
    ];
    events.forEach((event) => document.addEventListener(event, resetTimer));

    resetTimer({ type: "initial" });

    return () => {
      events.forEach((event) =>
        document.removeEventListener(event, resetTimer)
      );
      window.clearTimeout(window.logoutTimer);
      window.clearTimeout(window.warningTimer);
      clearInterval(window.logoutCountdownInterval);
    };
  }, [resetTimer]);

  return { resetTimer, showWarning, remainingTime };
};

export default useAutoLogout;
